import util from '@bmp-vue/core/api/util'
import * as XLSX from 'xlsx';

const controller = 'Exportacao'
export default Object.assign({}, util.GetCrud(controller, ['none']), {
  GerarExcel: function (dto) {
    return util.Axios.PostBlob(controller + '/GerarExcel', dto)
  },
  ExportToExcel (th, data, schema, fileName = 'export.xlsx') {
    const headers = schema.map((col) => col.text);
    const formattedData = data.map((row) => {
      const formattedRow = {};
      schema.forEach(({ value, format }) => {
        let cellValue = row[value];
        if (format) {
          if (format === 'date') {
            cellValue = th.$api.UI.Format.Date(cellValue)
          } else if (format === 'documento') {
            cellValue = th.$api.UI.Format.DocumentoFederal(cellValue)
          }
        }
        formattedRow[value] = cellValue;
      });
      return formattedRow;
    });
    const excelData = [headers];
    formattedData.forEach((row) => {
      const rowData = schema.map((col) => row[col.value] || '');
      excelData.push(rowData);
    });
    const worksheet = XLSX.utils.aoa_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Dados');
    XLSX.writeFile(workbook, fileName);
  }
})
